import { items } from "./items";
import { customers } from "./customers";
import { orders } from "./orders";
import { users } from "./users";
import { stock } from "./stock";
import { meta } from "./meta";
import { salesInvoices } from "./salesInvoices";
import { stockEntries } from "./stockEntries";
import { stockReconciliations } from "./stockReconciliations";
import { itemPrices } from "./itemPrices";
import { pricingRules } from "./pricingRules";
import { reports } from "./reports";
import { listExport } from "./listExport";
import * as docs from "./docs";

export const erp = {
  items,
  customers,
  orders,
  users,
  stock,
  salesInvoices,
  stockEntries,
  stockReconciliations,
  itemPrices,
  pricingRules,
  reports,
  listExport,
  meta,
  docs,
};

// Re-export types
export type { DocSidebarData, DocConnectionsResponse, DocConnectionGroup, LinkedDoc, RelationshipGraphResponse, RelationshipGraphGroup } from "./docs";

// Re-export types for convenience
export type * from "./types/item";
export type { ItemWithVariants } from "./types/item";
export type * from "./types/customer";
export type * from "./types/order";
export type * from "./types/user";
export type * from "./types/stock";
export type * from "./filterTypes";
export type * from "./meta";
export type { SalesInvoice } from "./salesInvoices";
export type { StockEntry } from "./stockEntries";
export type { StockReconciliation } from "./stockReconciliations";
export type { ItemPrice } from "./types/item";
export type { PricingRule } from "./pricingRules";
export type {
  ReportFieldInfo,
  ReportMeta,
  AggregationType,
  ReportGroup,
  GroupedReportData,
  FlatReportData,
  ReportData,
  ReportDataParams,
} from "./reports";

